module.exports = __webpack_public_path__ + "static/img/11.8d8653f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/11.png
// module id = jRi1
// module chunks = 0